import { AssignmentStage } from 'constants/assignment'
import { useGalleryConstants } from './GalleryConstants.context'
import { useGalleryProduct } from './GalleryProduct.context'

/**
 * The stages from which an admin may send the assignment to the client.
 * A Floorfy tour has no editor step, so it unlocks from the CT's submission. Every other product waits for the editor.
 */
export function useStagesUnlockingSendToClient(): Set<AssignmentStage> {
  const { stagesUnlockingSendAssignmentVisualsToClient, stagesUnlockingSendFloorfyTourToClient } = useGalleryConstants()
  const { isVirtualVisitFloorfy } = useGalleryProduct()

  return isVirtualVisitFloorfy ? stagesUnlockingSendFloorfyTourToClient : stagesUnlockingSendAssignmentVisualsToClient
}
